import styled from "styled-components";

type HoverExpandButtonProps = {
    size?: number;
    radius?: number;
    backgroundColor: string;
    borderColor: string;
}

type IconWrapProps = {
    size?: number;
}

type LabelProps = {
    color: string;
}

export const HoverExpandButton = styled.button<HoverExpandButtonProps>`
    height: ${props => props.size ?? 36}px;
    max-width: ${props => props.size ?? 36}px;
    overflow: hidden;
    border-radius: ${props => props.radius ?? 25}px;
    border: 1px solid${(props) => props.borderColor};
    background: ${props => props.backgroundColor};
    cursor: pointer;
    display: inline-grid;
    align-items: center;
    padding: 0;

    transition: none;

    &:hover {
        max-width: 420px;
        justify-content: space-around;
        display: flex;
        padding: 0 8px;
        transition: max-width 200ms ease, border-color 180ms ease;
    }
`;

export const Label = styled.span<LabelProps>`
    white-space: nowrap;
    font-size: 14px;
    color: ${props => props.color};
    letter-spacing: 0.7px;
    opacity: 0;
    transform: translateX(-4px);

    /* antes estava 12px, isso deixava “sobrando” muito espaço */
    padding-right: 8px;
    padding-left: 4px;
    transition: none;

    ${HoverExpandButton}:hover & {
        opacity: 1;
        transform: translateX(0);
        transition: opacity 140ms ease, transform 180ms ease, padding 180ms ease;
    }
`;

export const IconWrap = styled.span<IconWrapProps>`
    width: ${props => props.size ?? 36}px;
    height: ${props => props.size ?? 36}px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
`;